<template>
  <div>
    <div 
      :class="{ 'is-clickable': !disabled }" 
      @click="disabled ? '' : open = true">
      <component :is="productComponent">
        <span v-if="!value && !product">
          Select a product
        </span>
        <template v-else>
          <div 
            class="menu-label mb-0" 
            v-if="showCategory && category">
            {{ category.category }}
          </div>
          <div v-if="product && product.name">
            {{ product.name }}
          </div>
          <div v-else>
            Select a product
          </div>
        </template>
      </component>
    </div>

    <div
      class="modal has-overflow"
      :class="{ 'is-active': open }">

      <div class="modal-background"
        @click="close()">
      </div>
      
      <div class="modal-content">

        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Select A Product</p>
            <button
              class="delete"
              aria-label="close"
              @click="close()">
            </button>
          </header>

          <div class="modal-card-body pb-5">

            <div class="field">
              <label class="label">Product Category*</label>
              <v-select
                v-if="categories.length > 0"
                required
                :disabled="disableCategory"
                :options="categories"
                item-value="id"
                item-text="category"
                :value="categoryId"
                @input="changedCategory($event)"
              />
            </div>

            <!-- <div class="field">
              <label class="label">Product Subcategory*</label>
              <v-select
                v-if="categories.length > 0"
                required
                :options="categories"
                item-value="id"
                item-text="category"
                :value="categoryId"
                @input="changedCategory($event)">
              </v-select>
            </div> -->

            <div class="field">
              <div class="label-and-button pb-2">
                <label class="label mb-0">Product*</label>
                <span 
                  class="tag pointer" 
                  @click="addingProduct = true">
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Add a Product</span>
                </span>
              </div>
              <template v-if="categoryId">
                <product-search
                  v-if="hasProductSearch"
                  required
                  :product-category-id="categoryId"
                  :value="value"
                  :selected.sync="productSelected"
                  @input="changedProduct($event)"/>
                <template v-else>
                  <v-select
                    v-if="!loading"
                    required
                    :options="products"
                    item-value="id"
                    item-text="name"
                    :value="value"
                    @input="changedProduct($event)"
                  />
                  <span v-else class="has-text-grey-light">
                    No products in this category
                  </span>
                </template>
              </template>
              <span v-else class="has-text-grey-light">
                Please select a category
              </span>
            </div>

          </div>

        </div>
      </div>

      <add-product-modal
        v-if="addingProduct" 
        v-model="addingProduct"/>

    </div>
  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import ProductSearch from '@/components/inventory/ProductSearch'
import AddProductModal from '@/components/inventory/AddProductModal'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { VSelect, ProductSearch, AddProductModal },
  props: {
    value: {
      type: [String, Number]
    },
    productObject: {
      type: Object
    },
    productCategoryId: {
      type: [String, Number]
    },
    productCategoryObject: {
      type: Object
    },
    showCategory: {
      type: Boolean,
      default: false
    },
    disableCategory: {
      type: Boolean,
      default: false
    },
    hasProductSearch: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      categoryId: null,
      productSelected: null,
      products: [],
      loading: false,
      addingProduct: false
    }
  },
  computed: {
    ...mapState("products", ["categories"]),
    category({ categories, categoryId }) {
      return categories.filter(d => d.id == categoryId )[0];
    },
    product() {
      return this.hasProductSearch ? this.productObject ? 
        this.productObject : this.productSelected : 
        this.products.filter(d => d.id == this.value)[0];
    },
    productComponent() {
      return this.disabled ? 'div' : 'a';
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("products", ["getCategories"]),
    ...mapMutations("products", ["setProducts", "setCategories"]),
    initialize() {
      if (this.categories.length == 0) {
        if (this.disableCategory && this.productCategoryObject) {
          this.categoryId = this.productCategoryObject.id;
          this.setCategories([this.productCategoryObject]);
          this.getCategories();
        } else {
          this.getCategories();
        }
      }

      if (this.productObject) {
        this.setProducts([this.productObject]);
      }

      if (this.productCategoryId) {
        this.categoryId = this.productCategoryId;
        if (!this.hasProductSearch) {
          this.getProducts();
        }
      } else {
        if (this.value) {
          this.$http.product.get(this.value)
            .then(resp => {
              this.categoryId = resp.data.product_category_id;
              if (!this.hasProductSearch) {
                this.getProducts();
              }
            })
        }
      }
    },
    getProducts() {
      this.$http.products.get({ 
        product_category_id: this.categoryId, 
        simplified: true,
        per_page: 1000 })
        .then(resp => {
          this.loading = false;
          this.products = resp.data.results;
        })
    },
    changedCategory(id) {
      this.categoryId = id;
      this.$emit('input', null);
      this.loading = true;
      this.$http.products.get({ 
        product_category_id: id,
        simplified: true,
        per_page: 1000 
      }).then(resp => {
        this.loading = false;
        this.products = resp.data.results;
      })
    },
    changedProduct(v) {
      if (v) {
        this.$emit('input', v);
        this.close();
      } 
    },
    close(clear=false) {
      this.open = false;
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/modal.scss';

.modal-card-body {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.is-clickable {
  cursor: pointer;
}

.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>